import { Fields } from "@smartsuite/types";
import cx from "classnames";
import { Text, Tooltip } from "@smartsuite/react-ui/lib";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon";
import { disabledFieldTypes } from "../global.constants";
import { IconSizes } from "@smartsuite/icons";

export interface SidebarFieldListProps {
  iconName: string;
  iconSize?: IconSizes;
  label: string;
  className?: string;
  fieldType?: Fields;
  onClick: () => void;
}

export const SidebarFieldButton: React.FC<SidebarFieldListProps> = ({
  iconName,
  iconSize = "M",
  label,
  className,
  fieldType,
  onClick,
}) => {
  const disabled = fieldType ? disabledFieldTypes.includes(fieldType) : false;

  const buttonClasses = cx("sidebar-field-button", className, {
    "sidebar-field-button--disabled": disabled,
  });
  const textClasses = cx("sidebar-field-button__label", {
    "sidebar-field-button__label--disabled": disabled,
  });

  return (
    <Tooltip
      text="Field type not available yet"
      padding={2}
      placements={["right"]}
      disabled={!disabled}
      className="sidebar-field-button__item"
      target={
        <button className={buttonClasses} onClick={onClick} disabled={disabled}>
          <Icon
            className="sidebar-field-button__icon"
            name={iconName}
            size={iconSize}
            color="currentColor"
          />
          <Text weight="medium" wrapMode="ellipsis" className={textClasses}>
            {label}
          </Text>
          {!disabled && (
            <Icon
              className="sidebar-field-button__plus"
              name="plus"
              size="S"
              color="currentColor"
            />
          )}
        </button>
      }
    />
  );
};
